import { Controller } from '@hotwired/stimulus'

// Mémorise la position de défilement horizontale d'un élément à travers le cache de
// Turbo : la copie de page rejouée au retour arrière ne garde que le scroll du
// document, pas celui des éléments qui défilent en interne (bande de catégories
// d'Explorer, réinitialisée au retour d'une fiche). Clé : adresse de la page + `key`.
const positions = new Map()

export default class extends Controller {
  static values = { key: String }

  connect() {
    const saved = positions.get(this.#key)
    if (saved) this.element.scrollLeft = saved
    document.addEventListener('turbo:before-cache', this.save)
  }

  disconnect() {
    document.removeEventListener('turbo:before-cache', this.save)
  }

  save = () => {
    positions.set(this.#key, this.element.scrollLeft)
  }

  get #key() {
    return `${window.location.pathname}#${this.keyValue}`
  }
}
